<template>
  <div>
    <div
      v-if="showBreadcrumb"
      class="flex flex-row items-center h-7 px-1 text-sm leading-5"
    >
      <button
        type="button"
        class="text-green-500 cursor-pointer"
        @click="goToIntegrations"
      >
        {{ $t('INTEGRATION_SETTINGS.PAGE.BREADCRUMB_ROOT') }}
      </button>
      <span
        class="material-symbols-outlined text-[24px] leading-none text-gray-400 rtl:rotate-180 mx-1.5"
      >
        chevron_right
      </span>
      <span class="text-gray-500">{{ title }}</span>
    </div>
    <div
      class="flex flex-row items-start justify-between"
      :class="[
        {
          'mt-4': showBreadcrumb,
          'min-h-[40px]': showBreadcrumb || $slots.actions,
        },
        titleRowClass,
      ]"
    >
      <div class="flex flex-row items-center h-8">
        <h1 class="text-[24px] leading-8 font-bold text-gray-600 mb-0">
          {{ title }}
        </h1>
        <integration-hint
          v-if="hasHint"
          class="ltr:ml-2 rtl:mr-2"
          :title="hintTitle"
          :description="hintDescription"
        >
          <template v-if="$slots.hint">
            <slot name="hint" />
          </template>
        </integration-hint>
      </div>
      <slot name="actions" />
    </div>
    <div v-if="description" class="text-base leading-6 text-gray-600 mt-1">
      {{ description }}
    </div>
  </div>
</template>

<script>
import IntegrationHint from './IntegrationHint.vue';

export default {
  name: 'IntegrationPageHeader',
  components: { IntegrationHint },
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    hintTitle: { type: String, default: '' },
    hintDescription: { type: String, default: '' },
    showBreadcrumb: { type: Boolean, default: true },
    titleRowClass: { type: String, default: '' },
  },
  computed: {
    hasHint() {
      return !!(this.hintTitle || this.hintDescription);
    },
  },
  methods: {
    goToIntegrations() {
      this.$router.push({ name: 'settings_integrations' });
    },
  },
};
</script>
